import Vue from "vue";
import titleMixin from "@/mixins/title";
import spinnerMixin from "@/mixins/spinner";
export default Vue.extend({
    mixins: [titleMixin, spinnerMixin],
    data() {
        return {
            id: this.$route.params.id,
            title: this.$t("serviceMarketingCategories.edit.title", { name: "" }),
            data: {},
            validationOptions: {
                rules: {
                    name: {
                        required: true,
                        rangeLength: [3, 50]
                    },
                    description: {
                        maxLength: 255
                    }
                }
            }
        };
    },
    methods: {
        edit() {
            return this.$store.dispatch("serviceMarketingCategory/edit", {
                id: this.id,
                serviceMarketingCategory: this.data
            });
        },
        editSuccess() {
            this.$toast.showSuccessToast(this.$t("serviceMarketingCategories.edit.toastSuccessTitle"), this.$t("serviceMarketingCategories.edit.toastSuccessContent", {
                name: this.data.name
            }));
            return this.$router.push("/administration/service-marketing-categories");
        },
        cancel() {
            return this.$router.push("/administration/service-marketing-categories");
        }
    },
    async mounted() {
        this.showSpinner();
        try {
            this.data = await this.$store.dispatch("serviceMarketingCategory/get", {
                id: this.id
            });
            this.title = this.$t("serviceMarketingCategories.edit.title", { name: `${this.data.name}` });
        }
        catch (errors) {
            this.$toast.showDangerToast(this.$t("shared.toastFailureTitle"), this.$t("shared.toastFailureContent", {
                error: errors[0].message
            }));
            await this.$router.push("/administration/service-marketing-categories");
        }
        finally {
            this.hideSpinner();
        }
    }
});
